// Start of Event Service code
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { filter, map } from "rxjs/operators";

// Used to store key value pairs
interface InfoType {
  key: string;
  value: any;
}

@Injectable({
  providedIn: "root",
})
export class InfoSharingService {
  protected infoSubject = new Subject<InfoType>();

  /*Method is responsible for Broadcast Event */
  public broadcastInfo(key: string, value: any): void {
    this.infoSubject.next({ key, value });
  }

  /* Method is responsible for Get Event*/
  public getInfo(key: string): Observable<any> {
    return this.infoSubject.asObservable().pipe(
      filter((e) => e.key === key),
      map((e) => e.value),
    );
  }
}
